import dynamic from "next/dynamic"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import Head from 'next/head'
import MetaTags from '../src/MetaTags'
import LayoutFirebase from '../src/LayoutFirebase'

const ColorExtractorWithEditor = dynamic(
  () => import("../src/ColorExtractorWithEditor"),
  { ssr: false },
)

const ColorExtractorPage = (props) => {
  const title = "Free Color Palette Generator from Image | Browser-Based Tool"
  const description = "Generate color palettes from any image with our free, browser-based color palette generator. Instant results, no data upload, fully customizable in your browser."
  const heading = "Color Palette Generator from Image"

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://moodboardai.com/color-palette-generator#webpage",
        "url": "https://moodboardai.com/color-palette-generator",
        "name": title,
        "isPartOf": {
          "@id": "https://moodboardai.com/#website"
        },
        "description": description,
        "inLanguage": "en-US"
      },
      {
        "@type": "WebApplication",
        "name": "Color Palette Generator",
        "operatingSystem": "All",
        "applicationCategory": "DesignApplication",
        "offers": {
          "@type": "Offer",
          "price": "0"
        }
      }
    ]
  }

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(structuredData),
          }}
        />
      </Head>
      <MetaTags
        title={title}
        description={description}
        image="/assets/color-palette-generator-demo.jpg"
        hasTranslation={false}
      />
      <LayoutFirebase>
        <div className="px-5 pt-12 mx-auto">
          <div className="flex flex-col text-center w-full mb-6">
            <h1 className="font-serif sm:text-4xl text-3xl font-medium mb-6 text-gray-900">
              {heading}
            </h1>
            <p className="lg:w-2/3 mx-auto leading-relaxed text-base  max-w-3xl">
              {description}
            </p>
          </div>
        </div>
            <ColorExtractorWithEditor />
            <div className="mt-12 pt-8 px-5 border-t border-gray-200">
              <h2 className="font-serif text-3xl text-gray-600 py-2 text-center">
                Why Choose Our Color Palette Generator?
              </h2>
              <ul className="mt-4 list-disc list-inside space-y-2 text-left max-w-2xl mx-auto">
                <li>Color extraction for accurate, harmonious palettes</li>
                <li>Generate color schemes from any image in seconds</li>
                <li>100% free and browser-based - no software installation required</li>
                <li>No data upload - your images stay private on your device</li>
                <li>Built-in editor for fine-tuning your generated palette</li>
                <li>Instant generation of complementary and accent colors</li>
                <li>Smart identification of dominant, accent, and neutral tones</li>
              </ul>
            </div>
        <div className="max-w-5xl px-5 mx-auto mt-12">
          <h2 className="font-serif text-3xl text-gray-600 py-2 text-center">
            How to Use Our Color Palette Generator
          </h2>
          <ol className="list-decimal list-inside space-y-2 text-left max-w-2xl mx-auto mt-4">
            <li>Upload an image</li>
            <li>Watch as our tool instantly generates a color palette</li>
            <li>Use the built-in editor to refine your generated palette</li>
            <li>Copy or download your custom color scheme for your projects</li>
          </ol>
          <p className="text-center mt-6">
            Start creating color palettes for your designs in seconds - it's free, fast, and works entirely in your browser!
          </p>
        </div>
      </LayoutFirebase>
    </>
  )
}

export default ColorExtractorPage

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
    revalidate: 86400, // daily (24 hours)
  }
}